module.exports = __webpack_public_path__ + "img/justify-left.4455ae94.svg";